import React from 'react';
import axios from 'axios';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import History from './history';

jest.mock('axios');

describe('History', () => {
  test('renders History component', async () => {
    const promise = Promise.resolve({
      data: {message_histories: [{
      message_send_at: "2020/01/01 00:09:00",
      phone__number: "09012341234",
      message: "オンライン服薬指導を予約いたしました。",
      m_user_name: "グッドな薬局渋谷店",
      consumed_ticket_count: 2,
      send_kbn: 0 }]} });

    (axios.get as any).mockResolvedValue(promise);

    render(<History />);

    await act(() => promise);

    // screen.debug();

    expect(screen.getByText('検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)')).toBeInTheDocument();
    expect(screen.getByText('オンライン服薬指導を予約いたしました。')).toBeInTheDocument();
    expect(screen.getByText('グッドな薬局渋谷店')).toBeInTheDocument();
  });
});
